import React from 'react';
import { useNavigate } from 'react-router-dom';

const ContactLogo = ({ className = "h-8 w-auto", clickable = false }) => {
  const navigate = useNavigate();
  
  const handleClick = () => {
    if (clickable) {
      navigate('/');
    }
  };

  const logoPath = '/custom-logo.png'

  return (
    <div 
      className={`${className} flex items-center ${clickable ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''}`}
      onClick={handleClick}
    >
      <img
        src={logoPath}
        alt="CONTACT Logo"
        className="h-8 w-auto"
        width={31}
        height={32}
      />
    </div>
  );
};

export default ContactLogo;
